import * as React from "react";
import Switch, { ReactSwitchProps } from "react-switch";
import styled, { css } from "styled-components";
import theme from "styled-theming";
import colors from "../styles/colors";
import { ThemeType } from "../styles/theme";

const customTextColorOn = theme("mode", {
    [ThemeType.light]: colors.white,
    [ThemeType.dark]: colors.white
});

const customTextColorOff = theme("mode", {
    [ThemeType.light]: colors.grey_1,
    [ThemeType.dark]: colors.grey_1
});

const customBorderOff = theme("mode", {
    [ThemeType.light]: colors.grey_2,
    [ThemeType.dark]: colors.grey_2
})

const customBorderOn = theme("mode", {
    [ThemeType.light]: colors.greenPrimary,
    [ThemeType.dark]: colors.greenPrimary
})

const CustomIcon = styled.div({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    fontSize: "10px",
    paddingRight: "2px"
});

const CustomUncheckedIcon = styled(CustomIcon)`
    color: ${customTextColorOff};
`

const CustomCheckedIcon = styled(CustomIcon)`
    color: ${customTextColorOn};
`

const StyledSwitch = styled(Switch) <ICustomToggleProps>`
    ${props => props.$inline ? css`
        display: inline-block;
    ` : css`
        display: block !important;
    `}
    .react-switch-bg {
        border-radius: 20px !important;
        border: 2px solid ${props => props.checked ? customBorderOn : customBorderOff};
        box-sizing: initial;
    }
    .react-switch-handle {
        top: 4px !important;
    }
`

const CustomToggle: React.FC<ICustomToggleProps> = (props) => {

    const handleDiameter = props.handleDiameter ?? 26;
    const height = props.height ?? 30;

    return (
        <StyledSwitch
            {...props}
            offColor={colors.grey_5}
            onColor={colors.greenPrimary}
            boxShadow={"0px 0px 3.45px rgba(0, 0, 0, 0.25)"}
            handleDiameter={handleDiameter}
            height={height}
            uncheckedIcon={
                <CustomUncheckedIcon>
                    OFF
                </CustomUncheckedIcon>
            }
            checkedIcon={
                <CustomCheckedIcon>
                    ON
                </CustomCheckedIcon>
            }
        />
    )
}

export interface ICustomToggleProps extends ReactSwitchProps {
    $inline?: boolean;
    height?: number;
    handleDiameter?: number;
}

interface ICustomToggleButton extends Partial<ICustomToggleProps> {
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
    id?: string;
}

export const CustomToggleButton: React.FC<ICustomToggleButton & React.PropsWithChildren> = ({
    children,
    id,
    onClick,
    ...rest
}) => (
    <button id={id} onClick={onClick}>
        {children}

        <CustomToggle
            $inline={true}
            height={20}
            handleDiameter={16}
            width={43}
            checked={rest.checked!}
            onChange={() => false}
        />
    </button>
);

export default CustomToggle;